module.exports = __webpack_public_path__ + "static/media/polymedia-peter-van-der-meer.e9f0b1e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/polymedia-peter-van-der-meer.png
// module id = 196
// module chunks = 0